import { ScrollArea, ScrollBar } from "@/components/ui/scroll-area";
import type { DescriptionBlock } from "@/data/types";

export function DescriptionBlocks({ blocks }: { blocks: DescriptionBlock[] }) {
  return (
    <>
      {blocks.map((block, i) => {
        if (block.type === "paragraph") {
          return (
            <p key={i} className="text-sm text-muted-foreground mb-3">
              {block.text}
            </p>
          );
        }
        return (
          <ScrollArea key={i} className="mb-4 w-full max-w-[75vw]">
            <table className="w-max text-sm border-collapse">
              <thead>
                <tr>
                  {block.headers.map((h) => (
                    <th
                      key={h}
                      className="text-left px-3 py-2 bg-muted font-semibold"
                    >
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {block.rows.map((row, ri) => (
                  <tr key={ri}>
                    {row.map((cell, ci) => (
                      <td key={ci} className="px-3 py-2 border-t border-border">
                        {cell}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
            <ScrollBar orientation="horizontal" />
          </ScrollArea>
        );
      })}
    </>
  );
}
